import { AuthContext } from "contexts/AuthContext";
import { useContext } from "react";
import Layout from "./Layout";

export const Lobby = () => {
  const { authorized } = useContext(AuthContext);
  return authorized ? <Layout /> : null;
};
